module.exports = __webpack_public_path__ + "img/status-report-badge-1.c9e30653.svg";